import { IStringDate } from './types';

export const isSameMonth = ({ date1, date2 }: { date1: IStringDate; date2: IStringDate }): boolean => {
  const date1Year = date1.split('-')[0];
  const date2Year = date2.split('-')[0];
  if (date1Year !== date2Year) return false;
  return date1.split('-')[1] === date2.split('-')[1];
};
